module.exports = __webpack_public_path__ + "img/ground-tile-winter.bf397a64.jpg";